import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { AppConfigs } from '@/config';

function TopLevelRedirect() {
  useEffect(() => {
    // Get the current pathname
    const currentPath = window.location.pathname;

    // Only redirect if the path is not /invitations
    if (currentPath !== '/invitations') {
      window.location.href = AppConfigs.atlasEnvUrl.toString();
    }
  }, []);
  return null;
}

// Change the route to use a wildcard matcher
export const Route = createFileRoute('/')({
  component: TopLevelRedirect,
});
